<template>
  <canvas ref="qrcodeCanvas"></canvas>
</template>

<script>
import QRCode from "qrcode";
export default {
  props: ["dataInfo"],
  mounted() {
    this.loadQRCode();
  },
  methods: {
    loadQRCode() {
      let content = this.dataInfo || "";
      let canvas = this.$refs.qrcodeCanvas;
      QRCode.toCanvas(canvas, content, (error) => {
        if (error) {
          console.error(error);
        }
      });
    },
  },
};
</script>
